import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import plusLearningImg from "../../../../assests/carouselWidget/plusLerning.png";

const PlusLearningCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#F1799A"
            title={texts.plusLearning}
            image={plusLearningImg}
            imageAlt={texts.plusLearning}
            link={`/${pathRouts.PLUSLEARNING}`}
        />
    );
};

export default PlusLearningCarouselWidget;
